import { render, staticRenderFns } from "./reportEditor.vue?vue&type=template&id=bec9eafc&lang=pug"
import script from "./reportEditor.vue?vue&type=script&lang=js"
export * from "./reportEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports